import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { globals } from '../config/globals';

@Injectable({
    providedIn: 'root'
})
export class CryptoService {

    constructor() { }

    public encrypt(value: any): string {

        if (!value)
            value = '';

        return CryptoJS.AES.encrypt(value, globals.md5.key).toString()
    }

    public encryptLocalStorage(localStorageName: string, value: any): void {

        var valueEncrypted = this.encrypt(value);

        localStorage.setItem(localStorageName, valueEncrypted);
    }

    public decrypt(value: any): string {

        if (!value)
            value = '';

        try {
            return CryptoJS.AES.decrypt(value, globals.md5.key).toString(CryptoJS.enc.Utf8) || '';
        } catch (error) {
            return '';
        }

    }

    public decryptLocalStorage(localStorageName: string): string {
        var valueStorage = localStorage.getItem(localStorageName);

        return this.decrypt(valueStorage) || '';
    }
}
